import { Barcode, Package, Tag } from '@phosphor-icons/react'
import type { ConsoleDetailRoute, ConsoleSection } from '../routes'
import { LabelsPage } from '../pages/pack/LabelsPage'
import { PackRunDetailPage } from '../pages/pack/PackRunDetailPage'
import { PackRunsPage } from '../pages/pack/PackRunsPage'
import { SkusPage } from '../pages/pack/SkusPage'

/** Sidebar entries for this area (in sidebar order). */
export const PACK_SECTIONS: ConsoleSection[] = [
  { path: 'pack-runs', label: 'Pack runs', icon: Package, group: 'Pack & lab', element: <PackRunsPage /> },
  { path: 'skus', label: 'SKUs', icon: Barcode, group: 'Pack & lab', element: <SkusPage /> },
  { path: 'labels', label: 'Labels', icon: Tag, group: 'Pack & lab', element: <LabelsPage /> },
]

/** Detail pages for this area: routed, not in the sidebar. */
export const PACK_DETAIL_ROUTES: ConsoleDetailRoute[] = [{ path: 'pack-runs/:id', element: <PackRunDetailPage /> }]
